import mock from './mock';

/* eslint-disable import/extensions */

import './data/apps/strategy';

mock.onAny().passThrough(); // forwards the matched request over network
